var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 71,
    viewBox: "0 0 68 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2305_20269)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.7202 0.382484C51.984 0.328084 51.2325 0.569746 50.6461 1.12351L50.6352 1.12896C49.5456 2.15558 49.4972 3.83993 50.4566 4.9921C57.3161 13.2247 61.4767 23.8053 61.4767 35.3633C61.4767 46.4078 57.6743 56.5523 51.3555 64.6174C50.4294 65.8003 50.525 67.4872 51.6479 68.4859C52.818 69.5238 54.6415 69.4166 55.6119 68.1863C62.7321 59.1531 67.022 47.7636 67.022 35.3633C67.022 22.4384 62.366 10.6102 54.6913 1.40684C54.1743 0.786126 53.4562 0.436884 52.7202 0.382484ZM42.6205 9.92863C41.8761 9.87109 41.1114 10.1117 40.5194 10.6697C39.4908 11.6405 39.3126 13.2646 40.1999 14.3693C44.8247 20.1162 47.6135 27.4096 47.6135 35.3633C47.6135 42.9485 45.073 49.9295 40.8281 55.5453C39.9685 56.6807 40.1831 58.3075 41.2451 59.2504C42.4761 60.344 44.3492 60.1014 45.339 58.7818C50.2328 52.2539 53.1588 44.1538 53.1588 35.3633C53.1588 26.1348 49.9401 17.6644 44.5972 10.9802C44.0884 10.3428 43.365 9.98617 42.6205 9.92863ZM32.5101 19.4912C31.7543 19.4294 30.9714 19.6782 30.3711 20.243L30.3549 20.254C29.3456 21.2052 29.1931 22.7613 30.0083 23.8828C32.3567 27.1077 33.7503 31.0699 33.7503 35.3633C33.7503 38.2925 33.0897 41.0614 31.9307 43.5527L6.80903 21.9431C5.84138 21.1117 4.36529 21.3802 3.73313 22.4934C1.67305 26.1285 0.478516 30.3217 0.478516 34.8021C0.478516 39.1931 1.62336 43.3105 3.60858 46.8981C4.47364 48.4605 6.60533 48.744 7.90293 47.5193L7.90834 47.5084C8.81777 46.6491 9.05708 45.2785 8.44987 44.1793C6.91106 41.3979 6.02381 38.2083 6.02381 34.8021C6.02381 32.919 6.3126 31.1072 6.81445 29.386L31.4542 50.5978C32.3581 51.3762 33.7093 51.1789 34.4164 50.2164C37.4746 46.0569 39.2956 40.926 39.2956 35.3633C39.2956 29.8396 37.5035 24.7374 34.4814 20.5918C33.9962 19.925 33.2661 19.5528 32.5101 19.4912Z",
    fill: "url(#paint0_linear_2305_20269)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2305_20269",
    x1: 14.1298,
    y1: 0.261638,
    x2: 72.2966,
    y2: 5.00257,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2305_20269"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 66.5435,
    height: 69.8707,
    fill: "white",
    transform: "translate(0.478516 0.375)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChip);
export default __webpack_public_path__ + "static/media/chip.08e6105b3794956bbcad2e75f8e2c326.svg";
export { ForwardRef as ReactComponent };